import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'acs-simple-input-dialog',
  templateUrl: './simple-input-dialog.component.html',
  standalone: false
})
export class SimpleInputDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      confirmText: string;
      denyText: string;
      inputLabel: string;
      title: string;
      maxLength: string | number;
      value: string;
    },
    private dialogRef: MatDialogRef<SimpleInputDialogComponent>
  ) {}

  public onNoClick(): void {
    this.dialogRef.close();
  }
}
